module.exports = __webpack_public_path__ + "static/media/bg-image-38.7c88448c.jpg";